import * as React from 'react';
import {Breadcrumbs, Stack, Grid, Typography, Box} from "@mui/material";
import {Link, useNavigate} from "react-router-dom";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import SearchIcon from "@mui/icons-material/Search";
import DownloadIcon from '@mui/icons-material/Download';
import {styled} from "@mui/material/styles";
import 'react-slideshow-image/dist/styles.css';
import { Slide } from 'react-slideshow-image';
import Container from '@mui/material/Container';
import axios from "../../axios";
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {useState} from "react";
import {formatPhoneNumber} from "../Service";
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import {useAuthentication} from "../auth/hooks/useAuthentication";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;


    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="Fermer"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const Img = styled('img')({
    top: '33px',
    left: '34px',
    display: 'block',
    width: {xs : '230px !important', md : '364px', lg :'426px'},
    height: 'auto',
    borderRadius: '5px',
    minHeight: '250px'
});

const ImgModal = styled('img')({
    top: '33px',
    left: '34px',
    display: 'block',
    width: '750px',
    height: 'auto',
    borderRadius: '5px'
});

const EstablishmentHeader = ({establishment, latitude, longitude}) => {
    const [open, setOpen] = useState(false);
    const [modalSource, setModalSource] = useState("");
    const [modalAlt, setModalAlt] =useState("");
    const {isAuthenticated} = useAuthentication();

    const handleClickOpen = (src,alt) => {
        setModalSource(src);
        setModalAlt(alt);
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setModalSource("");
        setModalAlt("");
    };
    const navigate = useNavigate();

    const openGoogleMap = () => {
        window.open("https://www.google.com/maps/search/?api=1&query="+latitude+","+longitude, "_blank")
    }

    const onDownload = (registration) => {
        if (registration.uri) {
            const link = document.createElement("a");
            link.download = registration.filename;
            link.href = `${axios.defaults.apiBaseURL}${registration.uri}`;
            link.click();
        }
    };
    const {mode} = useDarkMode();

    return (
        <Container className={'container'}>
            <BootstrapDialog
                onClose={handleClose}
                aria-label="Agrandir l'image"
                open={open}
                maxWidth="lg"
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <ImgModal alt={modalAlt} src={modalSource}/>
                </DialogContent>
            </BootstrapDialog>
            <br/>
            <Breadcrumbs separator="›" aria-label="Navigation" style={{color : mode.settings.textColor3}}>
                <Typography className={'breadcrumbs'} variant={'body2'} onClick={() => navigate('/')} style={{color : mode.settings.breadcrumbColor1}}>
                    Accueil
                </Typography>,
                <Typography
                    className={'breadcrumbs'} variant={'body2'}
                    onClick={() => {isAuthenticated ? navigate('/product-search') : navigate('/professional')}}
                    style={{color : mode.settings.breadcrumbColor1}}
                >
                    Etablissement
                </Typography>,
                <Typography variant={'body2'} style={{color : mode.settings.textColor3}}>
                    {establishment.name.text}
                </Typography>,
            </Breadcrumbs>
            <Grid container>
                <Grid xs={12} lg={7.5} md={12} item>
                    <Typography component={'div'} id={'communityDetail'}>
                        <Typography variant={'h2'}>{establishment.name.text}</Typography>
                        <Typography component={'div'} variant={'h4'} id={'communityStat'}>
                            <LocationOnIcon role="img" aria-label={"Emplacement de l'établissement"} style={{marginRight :9}}></LocationOnIcon>
                            <Stack direction={"row"} spacing={1}>
                                <Typography
                                    className={"phoneLink"}
                                    onClick={openGoogleMap}
                                    aria-label={"Ouvrir l'établissement dans google Map"}
                                    sx={{cursor:'pointer'}}
                                >{establishment.road.text}</Typography>
                                <Typography
                                    className={"phoneLink"}
                                    onClick={openGoogleMap}
                                    aria-label={"Ouvrir l'établissement dans google Map"}
                                    sx={{cursor:'pointer'}}
                                >{establishment.zipcode.text+" "+establishment.city.text}</Typography>
                            </Stack>
                            <LocalPhoneIcon role="img" aria-label={"Numéro téléphone de l'établissement"}></LocalPhoneIcon>
                            <a aria-label={"Appeler l'établissement"} className={"phoneLink"} style={{marginRight :9}} href={`tel:'${establishment.phone.text}`}>{formatPhoneNumber(establishment.phone.text)}</a>
                        </Typography>
                    </Typography>
                    {/*<Typography component={'div'} variant={'subtitle1'} id={'communityHeaderSearchContainer'}>*/}
                    {/*    <Button*/}
                    {/*        className = "buttonOhs"*/}
                    {/*        startIcon={<DownloadIcon role="img" aria-label={"Téléchager le formulaire d'admission"}/>}*/}
                    {/*        onClick={() => onDownload(establishment.registration)}*/}
                    {/*    >*/}
                    {/*        <Typography variant={'subtitle3'}>Téléchager le formulaire d'admission</Typography>*/}
                    {/*    </Button>*/}
                    {/*</Typography>*/}
                </Grid>
                <Grid xs lg={3.5} md item>
                    <Box
                        sx={{
                            width: {xs : '100%', md : '364px', lg :'455px'},
                            height: '280px',
                            backgroundImage: `url(${axios.defaults.apiBaseURL}${establishment.image.uri}) , url(${process.env.REACT_APP_DEV_HOST}/assets/img/service0.jpg)`,
                            backgroundSize : 'cover',
                            backgroundPosition : 'center'
                        }}
                        onClick={() => handleClickOpen(`${axios.defaults.apiBaseURL}${establishment.image.uri}`, establishment.image.alternativeText)}
                    >

                    </Box>

                </Grid>
            </Grid>
            {Object.keys(establishment.relations.carousel_12).length !== 0 ?
            <div className="slide-container">
                <Slide
                    slidesToScroll={1}
                    indicators={true}
                    responsive={[{
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: establishment.relations.carousel_12.relations.image.length <= 6? establishment.relations.carousel_12.relations.image.length : 6,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 800,
                        settings: {
                            slidesToShow: establishment.relations.carousel_12.relations.image.length <= 4? establishment.relations.carousel_12.relations.image.length : 4,
                            slidesToScroll: 3
                        }
                    }, {
                        breakpoint: 500,
                        settings: {
                            slidesToShow: establishment.relations.carousel_12.relations.image.length <= 3? establishment.relations.carousel_12.relations.image.length :3,
                            slidesToScroll: 2
                        }
                    }]}
                >
                    {establishment.relations.carousel_12.relations.image.map((slideImage, index)=> (
                        <Box className="each-slide" key={index}
                             onClick={() => handleClickOpen(`${axios.defaults.apiBaseURL}${slideImage.image.uri}`)}
                             sx={{
                                 backgroundImage: `url(${axios.defaults.apiBaseURL}${slideImage.image.uri}) `,
                                 height :
                                     establishment.relations.carousel_12.relations.image.length <= 2? '400px' :
                                         establishment.relations.carousel_12.relations.image.length <= 4? '200px' :
                                         '150px'
                                 ,
                                 backgroundRepeat : 'round'
                             }}
                        >
                        </Box>
                    ))}
                </Slide>
            </div>: <div></div>}
        </Container>
    )
}

export default EstablishmentHeader;
